import React from "react";
import Input from "../Input";
// import Checkbox from "../Checkbox";
import logo from "../../../assets/logo_completa_branca.svg";
import { Logo, UserForm, BackgroundLogin, SubmitButton, Copyright } from "./styles";
import { VisibilityOffOutlined, VisibilityOutlined } from "@mui/icons-material";
import { loginForm } from "../../../utils/formVerifications";
import { useDispatch, useSelector } from "react-redux";
import { authHttpRequest, setValidUserEmail } from "../../../store/auth";
import EmailConfirmationForm from "../../EmailConfirmationForm";

export default function FormLogin() {
  const [password, setPassword] = React.useState(false);
  const { loading } = useSelector((state) => state.auth);
  const {validUserEmail} = useSelector(state => state.auth.data)
  const formRef = React.useRef(null);

  const dispatch = useDispatch();

  const haddleUserSubmit = async (data) => {
    formRef.current.setErrors({});
    const { payload, error } = await loginForm(data);
    if (payload){
      const response = await dispatch(authHttpRequest({
        url: '/auth/login',
        method: 'POST',
        data: data
      }))

      if(response.status){
        dispatch(setValidUserEmail(data.email))
      }
    }else if (error){
      formRef.current.setErrors(error);
    }
  };

  const visibilityPassword = () => setPassword(!password);
  return (
    <BackgroundLogin>
      <Logo src={logo} />
      {
        validUserEmail?
        <EmailConfirmationForm disabled={loading}/>
        :
        <UserForm ref={formRef} autoComplete="off" onSubmit={haddleUserSubmit}>
          <h1>Entrar</h1>
          <Input name="email" label="E-mail: *" autoFocus />
          <Input
            type={password ? "text" : "password"}
            name="password"
            label="Senha: *"
          >
            {password ? (
              <VisibilityOutlined
                style={{ color: "#fff", width: "25px", height: "25px" }}
                onClick={visibilityPassword}
              />
            ) : (
              <VisibilityOffOutlined
                style={{ color: "#fff", width: "25px", height: "25px" }}
                onClick={visibilityPassword}
              />
            )}
          </Input>
          <SubmitButton type="submit" disabled={loading}>
            Entrar
          </SubmitButton>
        </UserForm>
      }
      <Copyright>Copyright &copy; Conforce sem fronteiras 2021.</Copyright>
    </BackgroundLogin>
  );
}
